// Exportação para Excel. Mesma planilha da tela antiga (RelatorioVendas.js > exportarParaExcel).
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { buscarDadosExportacao } from './api';

export async function exportarParaExcel(params) {
  const XLSX = window.XLSX;
  if (!XLSX) {
    toast.error('Biblioteca de exportação não carregada.');
    return;
  }

  const toastId = toast.info('Buscando dados para exportação...', { autoClose: false });

  try {
    const todosOsDados = await buscarDadosExportacao(params);

    if (todosOsDados.length === 0) {
      toast.dismiss(toastId);
      toast.warning('Não há dados para exportar.');
      return;
    }

    const mapaGrupos = new Map();
    const anoAtual = new Date().getFullYear();

    todosOsDados.forEach(item => {
      const chave = String(item.id_curso_inst);
      if (!mapaGrupos.has(chave)) {
        mapaGrupos.set(chave, {
          nomeintituicao: item.nomeintituicao,
          sigla_instituicao: item.sigla_instituicao,
          nomecurso: item.nomecurso,
          nomecidade: item.nomecidade,
          siglaestado: item.siglaestado,
          nome_vendedor: item.nome_vendedor || item.vendedor || 'A definir',
          _children: []
        });
      }
      mapaGrupos.get(chave)._children.push(item);
    });

    mapaGrupos.forEach(grupo => {
      grupo._children.sort((a, b) => {
        const anoA = parseInt(String(a.Ano_Form || a.ano_formatura).split('/')[0], 10);
        const anoB = parseInt(String(b.Ano_Form || b.ano_formatura).split('/')[0], 10);
        return anoA - anoB;
      });

      // Status Range (Vinculado/Livre) com base nos últimos 2 anos
      const temVinculo = grupo._children.some(f => {
        const ano = parseInt(String(f.Ano_Form || f.ano_formatura).split('/')[0], 10);
        return ano >= anoAtual - 2 && f.idNegocioBitrix && f.idNegocioBitrix !== '' && f.idNegocioBitrix !== 'null';
      });
      grupo.statusRange = temVinculo ? 'Vinculado' : 'Livre';
    });

    toast.dismiss(toastId);
    toast.info('Gerando planilha...', { autoClose: 2000 });

    const formataData = (data) => {
      try { return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' }); } catch (e) { return ''; }
    };

    const calcRange = (filho) => {
      try {
        const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
        const anoTurma = parseInt(String(filho.Ano_Form || filho.ano_formatura).split('/')[0], 10);
        if (isNaN(anoTurma)) return '';
        const dataFinalPadrao = new Date(anoTurma, 0, 1);
        dataFinalPadrao.setDate(dataFinalPadrao.getDate() - 120);
        let dataFinal = dataFinalPadrao;
        if (filho.range_end_date) {
          const dc = new Date(filho.range_end_date);
          if (!(dc.getMonth() === 11 && dc.getDate() === 31 && dc.getFullYear() === anoTurma)) {
            dataFinal = dc;
          }
        }
        const dias = Math.ceil((dataFinal - hoje) / (1000 * 60 * 60 * 24));
        return `Até ${formataData(dataFinal)} (${dias < 0 ? 'Vencido' : dias + ' dias'})`;
      } catch (e) { return ''; }
    };

    const linhas = [
      ['Instituição', 'Sigla', 'Curso', 'Cidade', 'UF', 'Vendedor', 'Status Range', 'Ano', 'Range']
    ];

    mapaGrupos.forEach(grupo => {
      linhas.push([
        grupo.nomeintituicao,
        grupo.sigla_instituicao || '',
        grupo.nomecurso || '',
        grupo.nomecidade || '',
        grupo.siglaestado || '',
        grupo.nome_vendedor,
        grupo.statusRange,
        '',
        ''
      ]);
      grupo._children.forEach(filho => {
        linhas.push([
          `  ${grupo.nomeintituicao}`,
          grupo.sigla_instituicao || '',
          grupo.nomecurso || '',
          grupo.nomecidade || '',
          grupo.siglaestado || '',
          filho.nome_vendedor || filho.vendedor || 'A definir',
          '',
          String(filho.Ano_Form || filho.ano_formatura || ''),
          calcRange(filho)
        ]);
      });
    });

    const ws = XLSX.utils.aoa_to_sheet(linhas);
    ws['!cols'] = [
      { wch: 42 }, { wch: 10 }, { wch: 32 }, { wch: 20 }, { wch: 5 },
      { wch: 22 }, { wch: 12 }, { wch: 10 }, { wch: 32 }
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Relatório de Vendas');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const dataAtual = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
    saveAs(blob, `relatorio-vendas-${dataAtual}.xlsx`);

    toast.success(`Exportado com sucesso! ${todosOsDados.length} registros.`);
  } catch (error) {
    toast.dismiss(toastId);
    toast.error('Erro ao exportar planilha. Tente novamente.');
  }
}
